var map = {
	"./008-referee.png": 5684,
	"./blueKas.png": 6219,
	"./bulb.png": 4480,
	"./cards.png": 1155,
	"./cardsIcon.png": 2990,
	"./check-card.png": 3636,
	"./check-quiz.png": 63,
	"./check.png": 551,
	"./checkJoinedMatch.png": 6822,
	"./checkfalse.png": 9380,
	"./checktrue.png": 4966,
	"./close.png": 4856,
	"./comment-question-yellow.png": 2251,
	"./comment-question.png": 7722,
	"./congratulation.png": 5788,
	"./corner.png": 3646,
	"./daily-quiz-icon.png": 9453,
	"./daily-quiz.png": 4576,
	"./document.png": 7451,
	"./document2.png": 5837,
	"./draw.png": 7563,
	"./edit_manage_account.png": 6476,
	"./favCardsIcon.png": 3890,
	"./goals-joined-match.png": 1729,
	"./goals.png": 8433,
	"./goldKas.png": 5828,
	"./home.png": 3685,
	"./information.png": 7555,
	"./leaders.png": 6111,
	"./match-list.png": 6496,
	"./matchesIcon.png": 1647,
	"./news.png": 8736,
	"./no_trophy.png": 6945,
	"./points-earned.png": 2376,
	"./ranking.png": 3879,
	"./red-cards-joined-match.png": 9112,
	"./red-cards.png": 9949,
	"./save_manage_account.png": 5628,
	"./search.png": 5960,
	"./settings-sliders.png": 7374,
	"./settings.png": 4476,
	"./shot.png": 6101,
	"./sign-out-alt.png": 9957,
	"./soccer_ball.png": 4323,
	"./t-shirt.png": 4004,
	"./total-points.png": 8852,
	"./trophy-star.png": 5175,
	"./trophy_bronze.png": 5554,
	"./trophy_gold.png": 223,
	"./trophy_silver.png": 5461,
	"./whistle.png": 3269,
	"./winner-joined-match.png": 9177,
	"./winner.png": 4903,
	"./yellow-cards-joined-match.png": 2491,
	"./yellow-cards.png": 3380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;